import ErrorPage from 'next/error';
import { useRouter } from 'next/router';
import { docBySlugQuery, docSlugsQuery, navigationQuery } from '@lib/queries';
import { usePreviewSubscription } from '@lib/sanity';
import { getClient, sanityClient } from '@lib/sanity.server';
import { useRouteScroll } from '@hooks';
import { Box } from '@chakra-ui/react';
import { DocsSidenav, DocsHeader, DocsTemplate, DocsFooter } from '@components';

export default function DocsPage({ data, preview, navigation }: any) {
  const router = useRouter();
  useRouteScroll();

  const slug = data?.slug;
  const { data: docData } = usePreviewSubscription(docBySlugQuery, {
    params: { slug },
    initialData: data,
    enabled: preview && slug
  });

  if (!data || (!router.isFallback && !data.slug)) {
    return <ErrorPage statusCode={404} />;
  }

  return router.isFallback ? (
    <div>Loading...</div>
  ) : (
    <Box minH="100vh" bg="var(--bodyBg)" color="var(--primaryTextColor)">
      <DocsSidenav navigation={navigation} />
      <DocsHeader navigation={navigation} />
      <DocsTemplate content={docData} />
      <DocsFooter />
    </Box>
  );
}

export async function getStaticProps({ params, preview = false }: any) {
  const [data, navigation] = await Promise.all([
    getClient(preview).fetch(docBySlugQuery, {
      // Slug query requires full path including category
      slug: `/docs/${params.category}/${params.subcategory}/${params.slug}`
    }),
    getClient(preview).fetch(navigationQuery)
  ]);

  // Set SEO prop from data
  return {
    props: {
      seo: data?.seo || null,
      data,
      preview,
      navigation
    }
  };
}

export async function getStaticPaths() {
  const paths = await sanityClient.fetch(docSlugsQuery);
  const allowedPaths = paths.filter((path: any) => {
    return path.match(/\/docs\/[a-z0-9-]+\/[a-z0-9-]+\/[a-z0-9-]+/i);
  });

  return {
    paths: allowedPaths,
    fallback: 'blocking'
  };
}
